module.exports = __webpack_public_path__ + "img/adminGrey.dfe1ef92.svg";